import Box from "@mui/material/Box";
import { OrderStatusTypeEnum, OrderStatusType } from "../queries/getAll";

export const StatusBox = ({ status }: { status: string }) => {
  const getStatusColor = (statusInput: string) => {
    switch (statusInput) {
      case "canceled":
        return "#F44335";
      case "invoiced":
        return "#368369";
      default:
        return "#344767";
    }
  };

  return (
    <Box
      component={"span"}
      sx={{
        background: getStatusColor(status),
        color: "white !important",
        padding: "6px 12px",
        borderRadius: "6px",
      }}
    >
      {OrderStatusTypeEnum[status as OrderStatusType] ?? status}
    </Box>
  );
};
